var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-menu"},[_c('search-form',{on:{"open":function($event){return _vm.$emit('open')}}}),_vm._v(" "),(_vm.$store.state.screenWidth >= 980)?_c('span',[_vm._v(" | ")]):_vm._e(),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://clients.pixelcore.dev"}},[_vm._v("Client Login")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }